import {HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {map, catchError} from "rxjs/operators";
import {handleResponseStatusError, handleResponseBodyError} from "./common";

@Injectable()
export class CatchUnauthorizedInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req)
      .pipe(
        catchError(handleResponseStatusError),
        map(handleResponseBodyError),
      );
  }
}

export const CatchUnauthorizedInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: CatchUnauthorizedInterceptor,
  multi: true,
};
